import moment from 'moment';
import Constants from "./Constants";
import Time from "./Time";

const Intervention = {

  requiresRedFlag(intervention) {
    // 2h59 = 2
    // 3h00 = 3
    const redFlagLimit = Time.diffFromNow(intervention.previousWorkingDayClosingTime) < 3;
    return this.isTypeAppointmentOrBodywork(intervention) && redFlagLimit && this.isOpen(intervention);
  },

  duringWorkingHours(intervention) {
    const {journey: {properties = {}} = {}} = intervention;
    const {dropOff} = properties.reception;
    return dropOff.duringWorkingHours;
  },

  fastLane(intervention) {
    const {journey: {properties = {}} = {}} = intervention;
    const {dropOff} = properties.reception;
    return dropOff.fastLane;
  },

  getDisplayOrigin(origin, brand) {
    if (origin !== 'OAS') {
      return origin;
    }
    return `${origin}.` + (brand === 'MINI' ? brand : 'BMW');
  },

  isWeb(intervention) {
    return intervention.origin === 'WEB';
  },

  isOngoing(intervention) {
    const status = intervention.status || intervention.interventionStatus;
    return status === Constants.STATUS_ONGOING.value;
  },

  isAfterEndDate(intervention) {
    const {endDate} = intervention;
    return moment().isAfter(endDate);
  },

  isComplete(intervention) {
    return this.isOngoing(intervention) || this.isAfterEndDate(intervention);
  },

  isConfirmed(intervention) {
    const {journey: {status} = {}} = intervention;
    return status === 'CONFIRMED';
  },

  isTypeAppointment(intervention) {
    return intervention.journey && intervention.journey.type === Constants.TYPE_APPOINTMENT.value;
  },

  isTypeAppointmentOrBodywork(intervention) {
    return this.isTypeAppointment(intervention) || this.isTypeBodywork(intervention);
  },

  isTypeBodywork(intervention) {
    return intervention.journey && intervention.journey.type === Constants.TYPE_BODYWORK.value;
  },

  isTypeMessage(intervention) {
    return !intervention.journey || intervention.journey.type === Constants.TYPE_MESSAGE.value;
  },

  isTypeTire(intervention) {
    const {journey} = intervention;
    return journey && journey.type === Constants.TYPE_TIRES.value;
  },

  isArchived(intervention) {
    const status = intervention.status || intervention.interventionStatus;
    return status === Constants.STATUS_ARCHIVED.value;
  },

  isCancelled(intervention) {
    const status = intervention.status || intervention.interventionStatus;
    return status === Constants.STATUS_CANCELLED.value;
  },

  isDeleted(intervention) {
    const status = intervention.status || intervention.interventionStatus;
    return status === Constants.STATUS_DELETED.value;
  },

  isFinished(intervention) {
    const status = intervention.status || intervention.interventionStatus;
    return status === Constants.STATUS_FINISHED.value;
  },

  isOpen(intervention) {
    const status = intervention.status || intervention.interventionStatus;
    return status === Constants.STATUS_OPEN.value || status === Constants.STATUS_OPEN_48.value;
  },

  hasEndStatus(intervention) {
    return Intervention.isFinished(intervention) || Intervention.isCancelled(intervention) || Intervention.isDeleted(intervention) || Intervention.isArchived(intervention);
  },

  isOAS(intervention) {
    return intervention.origin === 'OAS';
  }

};

export default Intervention;
